/* eslint-disable max-lines */
/* eslint-disable no-param-reassign */
import { get } from 'lodash';
import app from '../app';

import { selectJk, selectJkHouse, setGeoObject, addJkMarkers } from '../../blocks/segments/address/address.events';

import deadlineQuarterEnum from '../enums/deadline-quarter';
import materialTypeNewBuildingEnum from '../enums/material-type-new-building';
// eslint-disable-next-line import/no-unresolved
import { LOCATIONS_TO_REPLACE } from '../../../../shared/constants';
import { getJKRegions } from '../../../../shared/utils/jk';

const events = {
  changeJk: 'jkService.changeJk',
  changeJkHouse: 'jkService.changeJkHouse',
  jkCatalogAddformCheck: 'jkService.jkCatalogAddformShowCheck',
};

app.service('jkService', [
  '$rootScope',
  '$q',
  'apiService',
  'addFormService',
  'addressService',
  '$timeout',
  'logger',
  // eslint-disable-next-line func-names
  function ($rootScope, $q, apiService, addFormService, addressService, $timeout, logger) {
    this.initializeEmptyJK = ({ force } = { force: false }) => {
      if (force || !addFormService.ad.geo.jk || !angular.isObject(addFormService.ad.geo.jk)) {
        addFormService.ad.geo.jk = {};
      }
    };

    this.setJKByKey = (key, value) => {
      addFormService.ad.geo.jk = {
        ...addFormService.ad.geo.jk,
        [key]: value,
      };
    };

    this.setAboutBuildingFromJk = (house = {}) => {
      const getKeyFromEnum = (key, enumArray, enumKey = 'key') => {
        const enumItem = enumArray.find(item => item[enumKey] === key);

        return angular.isObject(enumItem) ? enumItem[enumKey] : null;
      };

      addFormService.ad.isApartments = house.apartment || addFormService.ad.isApartments || false;
      if (!addFormService.ad.building.deadline) {
        addFormService.ad.building.deadline = {};
      }
      if (!addFormService.ad.building.parking) {
        addFormService.ad.building.parking = {};
      }
      addFormService.ad.building.deadline.year = house.finishYear || addFormService.ad.building.deadline.year || null;
      addFormService.ad.building.deadline.quarter = house.finishQuarter
        ? getKeyFromEnum(house.finishQuarter, deadlineQuarterEnum)
        : addFormService.ad.building.deadline.quarter || null;
      if (house.isFinished) {
        addFormService.ad.building.deadline.isComplete = house.isFinished;
        if (addFormService.form.deadlineIsComplete) {
          addFormService.form.deadlineIsComplete.$setTouched(true);
        }
      } else {
        addFormService.ad.building.deadline.isComplete = null;
        if (addFormService.form.deadlineIsComplete) {
          addFormService.form.deadlineIsComplete.$setTouched(false);
        }
      }
      addFormService.ad.building.materialType = house.materialType
        ? getKeyFromEnum(house.materialType, materialTypeNewBuildingEnum)
        : addFormService.ad.building.materialType || null;
      addFormService.ad.building.floorsCount = house.floors || addFormService.ad.building.floorsCount || null;
      addFormService.ad.building.parking.type = house.parking
        ? 'underground'
        : addFormService.ad.building.parking.type || null;
    };

    this.clearAboutBuilding = () => {
      addFormService.ad.isApartments = false;
      addFormService.ad.building = {
        materialType: null,
        floorsCount: null,
        parking: {
          type: null,
        },
        deadline: {
          year: null,
          quarter: null,
        },
        infrastructure: {},
      };
      if (addFormService.form.deadlineIsComplete) {
        addFormService.form.deadlineIsComplete.$setTouched(false);
      }
    };

    this.setNewJKFromObject = JK => {
      addFormService.ad.geo.jk = {
        id: JK.id,
        name: JK.name,
        developer: {
          id: null,
          name: '',
        },
        house: JK.house,
        isProblem: JK.isProblem,
        isTotallyProblem: JK.isTotallyProblem,
        problem: JK.problem,
        coordinates: JK.geo ? JK.geo.coordinates : null,
        cplEnabled: JK.cplEnabled,
      };
    };

    this.setupDeveloper = developerObj => {
      const developer = angular.isObject(developerObj)
        ? {
            ...developerObj,
          }
        : {
            id: null,
            name: '',
          };

      addFormService.ad.geo.jk.developer = {
        id: developer.id || null,
        name: developer.name || '',
      };
    };

    this.clearDeveloper = () => {
      addFormService.ad.geo.jk.developer = null;
    };

    this.setJkDeveloper = developers => {
      if (Array.isArray(developers) && developers.length > 0) {
        this.setupDeveloper(developers[0]);
      } else {
        this.clearDeveloper();
      }
    };

    this.addNewbuildingHouseMarkers = suggestions => {
      $timeout(
        () =>
          $rootScope.$emit(addJkMarkers, {
            jks: suggestions,
            isHouse: true,
          }),
        100,
      );
    };

    this.setBaseInfoAboutBuildingFromJk = () => {
      addFormService.ad.building.name = addFormService.ad.geo.jk.name;
      addFormService.ad.building.developer = addFormService.ad.geo.jk.developer.name;
    };

    this.mustSelectJk = () => getJKRegions().some(id => addressService.isLocation(id));

    this.isJkRegion = () => getJKRegions().find(id => addressService.isLocation(id));

    this.isJkCategory = addFormService.isJkCategory;

    this.isJkSecondaryCategory = () => addFormService.isJkSecondaryCategory();

    this.isJkSelected = (withCorpus = true) =>
      addFormService.ad &&
      addFormService.ad.geo &&
      addFormService.ad.geo.jk &&
      addFormService.ad.geo.jk.id &&
      (!withCorpus || (addFormService.ad.geo.jk.house && addFormService.ad.geo.jk.house.id));

    this.hasProblems = () => {
      if (!(addFormService.ad.geo.jk && addFormService.ad.geo.jk.id)) {
        return false;
      }

      const houseProblem = addFormService.ad.geo.jk.house && addFormService.ad.geo.jk.house.isProblem;

      return houseProblem;
    };

    this.showJkForm = () => this.isJkCategory() && this.mustSelectJk() && !this.isJkSelected(false);

    /**
     * Подписаться на привязку ЖК
     * @param handler обработчик function(jk){}
     * @return функция для отписки
     */
    this.onChangeJk = handler => $rootScope.$on(events.changeJk, (event, ...args) => handler(...args));
    const triggerChangeJk = jk => $rootScope.$emit(events.changeJk, jk);

    /**
     * Подписаться на привязку корпуса ЖК
     * @param handler обработчик function(jkHouse){}
     * @return функция для отписки
     */
    this.onChangeJkHouse = handler => $rootScope.$on(events.changeJkHouse, (event, ...args) => handler(...args));
    const triggerChangeJkHouse = jk => $rootScope.$emit(events.changeJkHouse, jk);

    this.triggerJkCatalogAddformCheck = () => $rootScope.$emit(events.jkCatalogAddformCheck);

    this.clearJk = () => {
      addFormService.ad.geo.jk = {};

      triggerChangeJk();
    };

    this.setGeoFromNewbuilding = geo => {
      if (geo && geo.address && geo.coordinates) {
        $rootScope.$emit(setGeoObject, geo);
      }
    };

    this.setNewbuildingModel = (newbuilding, options = { updateGeo: true }) => {
      addFormService.ad.geo.jk = newbuilding;

      if (options.updateGeo) {
        this.setGeoFromNewbuilding(newbuilding.geo);
      }
    };

    this.setNewbuildingHouseModel = (house, options = { updateGeo: true }) => {
      if (angular.isObject(addFormService.ad.geo.jk)) {
        addFormService.ad.geo.jk.house = house;
      }

      if (house && options.updateGeo) {
        this.setGeoFromNewbuilding(house.geo);
      }
    };

    /**
     * @param  {Object|string} jk Наименование ЖК или объект ЖК
     * @param  {boolean} isFormLayoutUpdateNotNeeded Флаг необходимости схлопнуть/расхлопнуть форму подачи
     */
    this.setJk = jk => {
      this.setNewbuildingModel(jk);

      triggerChangeJk(jk);
    };

    /**
     * @param  {Object|string} jkHouse Наименование корпуса или объект корпуса ЖК
     * @param  {boolean} isFormLayoutUpdateNotNeeded Флаг необходимости схлопнуть/расхлопнуть форму подачи
     */
    this.setJkHouse = jkHouse => {
      this.setNewbuildingHouseModel(jkHouse);

      triggerChangeJkHouse(jkHouse);
    };

    $rootScope.$on(selectJk, (event, { jk }) => {
      this.setJk(jk);
    });

    $rootScope.$on(selectJkHouse, (event, { jkHouse }) => {
      this.setJkHouse(jkHouse);
    });

    this.getJkByGeoObj = ({ id, type }) => {
      const deferred = $q.defer();
      if (angular.isNumber(id) && type === 'house') {
        apiService
          .jks({
            params: {
              geoId: id,
              geoType: type,
            },
          })
          .then(response => {
            if (response && response.data && response.data.data && Array.isArray(response.data.data.jks)) {
              deferred.resolve(response.data.data.jks[0]);
            }
            deferred.reject('no response');
          }, deferred.reject);
      } else {
        deferred.reject('geoObject format: {id: number, type: "house"}');
      }

      return deferred.promise;
    };

    const getNewbuildingsWithCitiesName = newbuildings => {
      return newbuildings.map(newbuilding => ({
        ...newbuilding,
        nameWithCity: newbuilding.geo.cityName ? `${newbuilding.name}, ${newbuilding.geo.cityName}` : newbuilding.name,
      }));
    };

    this.getJks = ({ term = '', geoId, geoType }) => {
      const deferred = $q.defer();
      if (term && term.length > 0) {
        apiService
          .jks({
            params: {
              term,
              geoId,
              geoType,
            },
          })
          .then(response => {
            let jks = [];

            if (response && response.data && response.data.data && response.data.data.jks) {
              jks = getNewbuildingsWithCitiesName(response.data.data.jks);
            }

            deferred.resolve(jks);
          }, deferred.reject);
      } else {
        deferred.resolve([]);
      }

      return deferred.promise;
    };

    this.getJkPreviewPhoto = () => {
      // eslint-disable-next-line consistent-return
      const photoPromise = $q((resolve, reject) => {
        const jkId = get(addFormService.ad, 'geo.jk.id');
        const jkHouseId = get(addFormService.ad, 'geo.jk.house.id');

        if (jkId) {
          const photos = get(addFormService.ad, 'geo.jk.photos');

          if (photos && Array.isArray(photos) && photos[0] && photos[0].miniUrl) {
            resolve(photos[0].miniUrl);

            return;
          }

          // сразу складываем данные для проблемных ЖК, чтобы не делать дублирующий запрос
          // eslint-disable-next-line consistent-return
          return this.getNewbuildingById(jkId).then(newbuilding => {
            const jkData = newbuilding;

            const jkDataHouses = (jkData && jkData.houses) || [];
            const houseData = jkDataHouses.find(house => house.id === jkHouseId);
            jkData.house = houseData;

            this.setJk(jkData, true);
            this.setJkHouse(houseData, true);

            // eslint-disable-next-line no-param-reassign
            addFormService.ad.geo.jk = jkData;

            const miniUrl = jkData?.photos[0]?.miniUrl;

            resolve(miniUrl);
          });
        }

        reject();
      });

      return photoPromise;
    };

    this.getJksWithCurrentGeo = ({ term = '' }) => {
      const locationId = addressService.locationId || addressService.getLocationId(addFormService.ad.geo.address); // Если locationId еще не установлен, используем getLocatonId
      const geoId = LOCATIONS_TO_REPLACE[locationId] || locationId;

      const params = {
        params: {
          term,
          geoId,
          geoType: 'location',
        },
      };

      return apiService.jks(params).then(response => {
        if (!response || !response.data || !response.data.data || !response.data.data.jks) {
          return [];
        }

        return getNewbuildingsWithCitiesName(response.data.data.jks);
      });
    };

    this.getNewbuildingById = newbuildingId => {
      if (!newbuildingId) {
        return Promise.reject('No newbuildingId error');
      }

      const params = {
        params: {
          newbuildingId,
        },
      };

      return apiService.getNewbuildingById(params).then(result => {
        const newbuilding = get(result, 'data.data.newbuilding');

        if (!newbuilding) {
          throw new Error(`No newbuilding with id:${newbuildingId} in response`);
        } else {
          return newbuilding;
        }
      });
    };

    this.updateNewbuildingFromDatabase = () => {
      const properties = Object.keys(addFormService.ad.geo.jk);

      if (properties.includes('name') && properties.includes('id')) {
        return this.getNewbuildingById(addFormService.ad.geo.jk.id)
          .then(newbuilding => {
            const isNewbuildingWithHouses = newbuilding.houses && newbuilding.houses.length;
            // Корпус может быть строкой, поэтому храним значение, чтобы потом установить в обновленный ЖК
            const savedHouse = addFormService.ad.geo.jk.house;
            const isHouseIdExists = Boolean(savedHouse && savedHouse.id);

            if (isNewbuildingWithHouses && isHouseIdExists) {
              const loadedHouse = newbuilding.houses.find(house => {
                return house.id === get(addFormService.ad.geo, 'jk.house.id');
              });

              if (!loadedHouse) {
                throw new Error(
                  `Saved house id ${savedHouse.id} does not exists in newbuilding (id:${newbuilding.id}) houses`,
                );
              }

              // Устанавливаем по порядку, так как модель вложенная
              this.setNewbuildingModel(newbuilding);
              this.setNewbuildingHouseModel(loadedHouse);
            } else {
              // Обновляем только модель ЖК моделью ЖК с сервера
              this.setNewbuildingModel(newbuilding);
              this.setNewbuildingHouseModel(savedHouse);
            }
          })
          .catch(error => {
            logger.error(error);
          });
      }

      return Promise.resolve();
    };
  },
]);
